// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"312":"7fa47823","355":"2ba7e8cd","791":"25c69e74"}[chunkId] + ".js";
};